import React, { useEffect, useState, useCallback } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

export function TabPanel({
  tabName,
  currentValue,
  index,
  project_id,
  columns,
  rows,
  onTableValueChange,
  toolbarDisabled,
  handleAddRow,
  handleDeleteRow,
  rowSelectionModel,
  setRowSelectionModel,
  footerText,
}) {
  const [tableValue, setTableValue] = useState(currentValue);
  const handleProcessRowUpdateError = useCallback((error) => {
    console.log(error.message);
  }, []);

  useEffect(() => {
    if (onTableValueChange) {
      onTableValueChange(tableValue);
    }
  }, [tableValue]);

  if (currentValue !== index) {
    return null;
  }

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        borderRadius: "8px",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        checkboxSelection
        disableRowSelectionOnClick
        processRowUpdate={(updatedRow, originalRow) => {
          const modified_at = new Date().toISOString();
          // 建立新的物件來保存轉換後的資料
          const typeCorrectedRow = Object.keys(updatedRow).reduce(
            (acc, key) => {
              const originalValue = originalRow[key];
              const newValue = updatedRow[key];
              // 特殊處理 active 欄位
              if (key === "active") {
                acc[key] = newValue === 'true' || newValue === '1' || newValue === true || newValue === 1;
              }
              // 其他欄位的類型處理
              else if (typeof originalValue === "number") {
                // 小數 - 保持原始精度
                const decimalPlaces = 2;
                acc[key] =
                  Number(parseFloat(newValue).toFixed(decimalPlaces)) ||
                  0;
              } else {
                // 字串或其他類型保持不變
                acc[key] = newValue;
              }
              return acc;
            },
            {}
          );
          typeCorrectedRow.modified_at = modified_at;
          setTableValue(typeCorrectedRow);
          return typeCorrectedRow;
        }}
        onProcessRowUpdateError={handleProcessRowUpdateError}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={(newSelection) => {
          setRowSelectionModel(newSelection);
        }}
        slots={
          toolbarDisabled
            ? { footer: Footer }
            : { toolbar: Toolbar, footer: Footer }}
        slotProps={{
          toolbar: { rowSelectionModel, handleAddRow, handleDeleteRow },
          footer: { footerText }
        }}
      />
    </Box>
  );
}

function Toolbar({ rowSelectionModel, handleAddRow, handleDeleteRow }) {
  const isDeleteRowDisabled = rowSelectionModel.length === 0;

  return (
    <GridToolbarContainer>
      <Button color="primary" startIcon={<AddIcon />} onClick={handleAddRow}>
        Add row
      </Button>
      <Button color="primary" startIcon={<DeleteIcon />} onClick={handleDeleteRow} disabled={isDeleteRowDisabled}>
        {
          rowSelectionModel.length >= 2 ? "Delete rows" : "Delete row"
        }
      </Button>
    </GridToolbarContainer>
  );
}

export function Footer({ footerText }) {
  return (
    <Box sx={{ p: 1, display: 'flex' }}>
      {footerText}
    </Box>
  );
}